import { Component } from "@kluntje/core";
/**
 * Custom Element to .. integrate sas ci360 loader
 */
class FRASasCi360 extends Component {
  constructor() {
    super({
      // nothing to override here
    });
  }

  /**
   * @override
   */
  afterComponentRender() {
    this.addEventListener("LoadXfEvent", e => {
      const _this = this;
      let ref = this.getAttribute("data-xf-content-ref");
      const variant = this.querySelectorAll("style[data-variant]");
      if (variant && variant.length == 1) {
        const dataVar = variant[0].getAttribute("data-variant");
        ref = `${ref.substring(0, ref.lastIndexOf("~2F"))}~2F${dataVar}.html`;
      }
      fetch(ref)
        .then(function (response) {
          // The API call was successful!
          return response.text();
        })
        .then(function (html) {
          // Convert the HTML string into a document object
          _this.innerHTML = html;
        })
        .catch(function (err) {
          // There was an error
          console.warn("Something went wrong.", err);
        });
    });
  }
}

customElements.define("fra-m-sas-ci360", FRASasCi360);

export default FRASasCi360;
